import React, { useEffect, useState } from "react";
import InsuranceDetails from "./components";
import Button from "../../../../components/common/button";
import { useLocation, useNavigate } from "react-router-dom";
import {
  buyNow,
  orderSummary,
  paymentSummary,
  profile,
} from "../../../../utils/router/constant";
import {
  formatAmount,
  getDecimalWithRupeeSymbol,
  getParamsFromURL,
  setParamsInURL,
} from "../../../../utils/helper";
import { createForm } from "../../../../service/proposal/proposalService";
import { useSelector } from "react-redux";
import Card from "../../../../components/cardView";
import Success from "../../../../components/paymentStatus/sucess";
import RedirectAlertModal from "../../../paymentSummary/RedirectAlertModal";
import OrderRestrictionModal from "../../../../components/common/OrderRestrictionModal";

const VariantCard = (props, type = {}) => {
  const location = useLocation();
  const nav = useNavigate();
  const [entityid, setEntityid] = useState(null);
  const [claim, setClaim] = useState(null);
  const [isDetailsVisible, setIsDetailsVisible] = useState(false);
  const toggleDetailsVisibility = () => {
    setIsDetailsVisible(!isDetailsVisible);
  };
  const createDetails = useSelector((state) => state.buyNow.createDetails);
  const agDetails = useSelector((state) => state.common.agDetails);
  const [showModal, setShowModal] = useState(false);
  const [showRestrictionModal, setShowRestrictionModal] = useState(false);
  const [restrictionError, setRestrictionError] = useState(null);

  const proposalData = useSelector((state) => state.buyNow.data);

  console.log(proposalData);

  useEffect(() => {
    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          setEntityid(params["entityid"]);
          setClaim(params["claim"]);
        } else {
          console.error("No parameters found");
        }
      });
    };
    fetchCode();
  }, [location]);

  // Determine the data structure
  const isMultipleVariants = Array.isArray(props.product_variants);
  const customerData = useSelector((state) => state.common.customerData);

  // Handle single or multiple product variants
  const productVariants = isMultipleVariants ? props.product_variants : [props];
  const isPremiumVisible = productVariants.some(
    (variant) => variant.final_premium === props.final_premium
  );

  const productAttributes = useSelector(
    (state) => state.product.productAttributes
  );

  const productType = productAttributes.type;

  const final_premium = props.final_premium;
  const cover_amount = props.cover_amount;
  const attribute_map = {};
  Object.keys(props.attribute_map || {}).forEach((key) => {
    attribute_map[key] = props.attribute_map[key];
  });

  // const handleSunccessFunction = async (res) => {
  //   const paramObject = {
  //     entityid: entityid,
  //   };
  //   if (res.entityid) {
  //     paramObject.orderId = res.entityid;
  //   }
  //   const params = await setParamsInURL(location, paramObject);
  //   // nav(`${orderSummary}?${params}`);
  //   if (productType === "UMBRELLA") {
  //     nav(`${paymentSummary}?${params}`);
  //   } else {
  //     nav(`${orderSummary}?${params}`);
  //   }
  // };

  // const handleSunccessFunction = async (res) => {
  //   const paramObject = {
  //     entityid: entityid,
  //   };
  //   if (res.entityid) {
  //     paramObject.orderId = res.entityid;
  //   }
  //   const params = await setParamsInURL(location, paramObject);
  //   const redirectUrl = createDetails.redirect_url;
  //   console.log("params", params)
  //   if (redirectUrl) {
  //     window.location.href = `${redirectUrl}?${params}`;
  //   } else {
  //     nav(`${orderSummary}?${params}`);
  //   }
  // };

  const handleSunccessFunction = async (res) => {
    const paramObject = { entityid: entityid };
    if (res.entityid) paramObject.orderId = res.entityid;

    const params = await setParamsInURL(location, paramObject);

    if (res.redirect_url) {
      setShowModal(true);
      // window.location.href = `${res.redirect_url}`;
    } else if (agDetails?.profile_enabled === false) {
      // profile_enabled false (MSCDA): after the quote go to profile (if not
      // filled yet), then proposal, then payment
      nav(`${customerData?.is_first_login === 1 ? profile : buyNow}?${params}`);
    } else {
      nav(`${orderSummary}?${params}`);
    }
  };

  const handleConfirmRedirect = () => {
    setShowModal(false);
    if (createDetails.redirect_url) {
      window.location.href = createDetails.redirect_url;
    }
  };
  const handleClickBuyNow = async () => {
    // const modifiedAttributeMap = { ...attribute_map };

    // if (modifiedAttributeMap.hasOwnProperty("qualification")) {
    //   modifiedAttributeMap["qualification"] = customerData?.qualification;
    // }
    const formState = {};
    try {
      await createForm(
        formState,
        entityid,
        final_premium,
        attribute_map,
        "ODR",
        cover_amount,
        customerData.parentid,
        handleSunccessFunction
      );
    } catch (error) {
      console.error("Failed to call createForm API", error);
      console.log("API Restriction Error Data:", error?.response?.data);
      if (
        error?.response?.data?.error_code &&
        ["ERR_022", "ERR_023", "ERR_024", "ERR_025"].includes(error.response.data.error_code)
      ) {
        setRestrictionError(error.response.data);
        setShowRestrictionModal(true);
      }
    }
  };

  const headerContent = (
    <>
      {props.recommended && (
        <div className="recommended--badge">Recommended</div>
      )}
      {/* {productType === "UMBRELLA" ? (
        <>
          <img
            height={"50px"}
            width={"90px"}
            src={productVariants[0]?.media_url}
            className="product-variant-image"
            alt="Product Variant"
          />
        </>
      ) : (
        <>
          {productVariants.map((variant, index) => (
            <img
              height={"50px"}
              width={"90px"}
              key={index}
              src={variant.media_url}
              className="product-variant-image"
              alt="Product Variant"
            />
            // </div>
          ))}
        </>
      )} */}
      {props.oems?.map((variant, index) => (
        <img
          height={"50px"}
          width={"90px"}
          key={index}
          src={variant.media_url}
          className="product-variant-image"
          alt="Product Variant"
        />
      ))}
    </>
  );

  const bodyContent = (
    <>
      {productType === "UMBRELLA" ? (
        <>
          <div className="insurancecard--content--left">
            <div>
              <h3 className="card--content--title">Insurer</h3>
              <h4 className="card--content--subtitle-umbrella">
                {props.oems?.map((variant) => variant?.name).join(" + ")}
              </h4>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="insurancecard--content--left">
            <h3 className="card--content--title">Cover</h3>
            <h3
              className="card--content--subtitle"
              title={
                props.product_variants[0].attribute_map?.cover ||
                "No cover info"
              }
            >
              {formatAmount(props.product_variants[0].attribute_map?.cover)}
            </h3>

            {/* {isMultipleVariants ? (
                <h3
                  className="card--content--subtitle"
                  title={props.cover || "No cover amount info"}
                >
                  {formatAmount(props.product_variants[0].cover_amount)}
                </h3>
              ) : (
                <h3
                  className="card--content--subtitle"
                  title={
                    props.product_variants[0].attribute_map?.cover || "No cover info"
                  }
                >
                  {formatAmount(props.product_variants[0].attribute_map?.cover)}
                </h3> */}
            {/* )} */}
          </div>
          {/* <div className="insurancecard--content--left">
              <div>
                <h3 className="card--content--title">Tenure</h3>
              </div>
              <h3 className="card--content--subtitle">1 yr</h3>
            </div> */}
        </>
      )}
    </>
  );

  const footerContent = (
    <div
      className={`insurance--card--footer ${isDetailsVisible ? "show" : ""}`}
    >
      {productVariants.map((variant, index) => (
        <InsuranceDetails
          key={index}
          product={variant}
          isVisible={isDetailsVisible}
          type={productType}
        />
      ))}
      <div
        className="insurance--detail--wrapper"
        style={{
          borderTop: "1px dashed #dcdcdc",
          paddingTop: "10px",
          marginTop: "10px",
        }}
      >
        <div className="details--wrapper--header">
          <div className="details--header--title">
            <h1 className="details--header--title--text">Total Premium (Incl.GST)</h1>
          </div>
          <h3 className="details--header--price">
            {getDecimalWithRupeeSymbol(props.final_premium)}
          </h3>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
        }}
      >
        <Button
          type="button"
          variant="primary"
          title="Buy Now"
          label="Buy Now"
          onClick={() => handleClickBuyNow()}
          style={{ width: "fit-content" }}
        />
      </div>
    </div>
  );

  return (
    <>
      <Card
        headerContent={headerContent}
        bodyContent={bodyContent}
        footerContent={footerContent}
        isDetailsVisible={isDetailsVisible}
        toggleDetailsVisibility={toggleDetailsVisibility}
        upscale_type={"RECOMMENDED"}
      />
      <RedirectAlertModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirmRedirect}
      />
      <OrderRestrictionModal
        show={showRestrictionModal}
        onHide={() => setShowRestrictionModal(false)}
        errorData={restrictionError}
        entityid={entityid}
      />
    </>
  );
};

export default VariantCard;
